import React, {useState} from "react";
import {ColorPicker, Spin} from "antd";
import {useRequest} from 'ahooks';
import HttpClient from "../utils/HttpClient";

const categoryServiceName = {
    "id": 5806,
    "manual": "#FE4C3C",
    "csv": "#17DE6B",
    "api": "#1976fe",
    "holidays": "Holidays",
    "google_algorithm_updates": "Google Updates",
    "retail_marketings": "Retail Marketing Dates",
    "weather_alerts": "Weather Alerts",
    "web_monitors": "Website Monitoring",
    "wordpress_updates": "WordPress Update",
    "google_alerts": "News Alerts",
    "g_ads_history_change": "Google Ads",
    "anomolies_detection": "#227c9d",
    "budget_tracking": "#227c9d",
    "keyword_tracking": "Keyword Tracking",
    "facebook_tracking": "Facebook",
    "instagram_tracking": "Instagram",
    "bitbucket_tracking": "Bitbucket tracking",
    "github_tracking": "Github",
    "twitter_tracking": "Twitter",
    "wordpress": "Wordpress",
    "shopify": "Shopify",
    "apple_podcast": "Apple Podcast",
    "linkedin_tracking": "#227c9d",
    "youtube_tracking": "Youtube",
    "tiktok_tracking": "Tiktok",
    "google_tag_manager_tracking": "GTM",
    "website_design_changes": "Website Design Changes",
    "blog_changes": "Blog Changes",
    "price_changes": "Price Changes",
    "competitor_website_changes": "Competitor Website Changes"
}

export const SystemColors = [
    '#D96FFF', '#A00CE6', '#17DE6B', '#00BB4F', '#04D6E3', '#1976FE', '#1324B0', '#FFB8BF',
    '#FE4C3C', '#DE180E', '#FFE082', '#FFC514', '#FF9147', '#FF6600', '#e6e9ee', '#24292f',
    '#253858', '#004f9d'
];

const UserAnnotationColorPicker = ({name, value, updateCallback, serviceName}) => {
    const [currentColor, setCurrentColor] = useState(value);

    const {data, loading, mutate} = useRequest(async () => {
        const [annotationResponse, categoriesResponse] = await Promise.all([
            HttpClient.get(`/data-source/user-annotation-color`),
            HttpClient.get(`/annotation-categories`)
        ]);

        return {
            userAnnotationColor: annotationResponse.data.user_annotation_color,
            categories: categoriesResponse.data.categories
        };
    }, {
        onSuccess: (data) => {
            const {userAnnotationColor, categories} = data;
            const selCat = categories.find(cat => cat.name === categoryServiceName[name]);

            if (selCat?.color) {
                setCurrentColor(selCat.color);
            } else if (userAnnotationColor?.[name]) {
                setCurrentColor(userAnnotationColor[name]);
            } else if (value) {
                setCurrentColor(value);
            }
        },
    });

    const saveCategory = async (newColor) => {
        try {
            const response = await HttpClient.post(`/annotation-categories`, {
                name: categoryServiceName[name],
                color: newColor,
                allowNew: true
            });
            const updatedCategories = [...(data?.categories || []), response.data];

            // Update user annotation color
            const userColorResponse = await HttpClient.post(`/data-source/user-annotation-color`, {[name]: newColor});

            // Mutate the data
            mutate({
                userAnnotationColor: userColorResponse.data.user_annotation_color,
                categories: updatedCategories
            });

            // Update the color in the parent component
            updateCallback(userColorResponse.data.user_annotation_color);
        } catch (error) {
            console.error("Error saving annotation category:", error);
        }
    };

    const handleChange = (color) => {
        const newColor = color.toHexString();
        setCurrentColor(newColor);
        saveCategory(newColor);
    };

    if (loading) {
        return <div className="position-relative mx-4"><Spin/></div>; // Or any loading indicator
    }

    return (
        <div className="position-relative mx-4">
            <ColorPicker
                value={currentColor}
                presets={[{label: 'Recommended', colors: SystemColors}]}
                onChange={handleChange}
            />
        </div>
    );
};

export default UserAnnotationColorPicker;
